import React from "react";

// COMPONENTS
import HeaderTaglineBox from "../common/headerTaglineBox";

const Wizard = (props) => {
  return (
    <div className="site-wrapper">
      <div className="page-header">
        <div className="page-header-inner">
          <HeaderTaglineBox />
        </div>
      </div>
      <div className="page">{props.children}</div>
    </div>
  );
};

export default Wizard;
